import { atom } from 'recoil';

import { OrderType } from '~/types/common';

const orderType = atom<OrderType>({
  key: 'orderType',
  default: OrderType.PLATFORM_PICKUP_POINT,
});

export default orderType;
